// extracted by mini-css-extract-plugin
export default {"root":"ProfileUser_root__odkPj","tabs":"ProfileUser_tabs__12wfF","spacer":"ProfileUser_spacer__gFYri","dangerCount":"ProfileUser_dangerCount__CeqJS"};